import { t } from 'i18next';
import { useMutation, useQueryClient } from 'react-query';

import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';
import { userSettingsService } from 'user/services';

export const useUserSettingsActions = () => ({
  ...useUpsertUserSetting(),
});

const useUpsertUserSetting = () => {
  const queryClient = useQueryClient();

  const { errors } = useHandleErrors({
    success: { message: t('messageUserSettingSaveSuccess') },
    loading: { message: t('messageUserSettingSaveInProgress') },
    error: { title: t('errorUserSettingSave') },
    position: NotificationPosition.TOP,
    invalidateQueries: ['authUser'],
  });

  const { mutateAsync } = useMutation((data) => userSettingsService.upsertUserSetting(data), {
    ...errors,
    onSuccess: (data, variables) => {
      errors?.onSuccess(data, variables);

      queryClient.setQueryData('removeLocalStorageLoggedUser', true);
    },
  });

  return {
    upsertUserSetting: (data, options: { onError?: () => void } = {}) =>
      mutateAsync(data, {
        ...options,
        onError: () => {
          options?.onError();
        },
      }),
  };
};
